module.exports = __webpack_public_path__ + "img/image27@2x.a1357e65.png";